import { EDIT_LISTING_HOMEOWNER,
         CLOSE_LISTING_HOMEOWNER,
         PENDING_SUBMIT_LISTING_HOMEOWNER,
         COMPLETE_SUBMIT_LISTING_HOMEOWNER,
         FAILED_SUBMIT_LISTING_HOMEOWNER
    } from "./mlTypes"


const initialState = {
    pendingsubmit: false,
    failedsubmit: false,
    completesubmit: false,
    propertyhomeownerediting: false
}


const mlListingHomeowner = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_LISTING_HOMEOWNER: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyhomeownerediting: true
        }

        case CLOSE_LISTING_HOMEOWNER: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyhomeownerediting: false
        }

        case PENDING_SUBMIT_LISTING_HOMEOWNER: return {
            ...state,
            pendingsubmit: true,
            failedsubmit: false,
            completesubmit: false
        }

        case COMPLETE_SUBMIT_LISTING_HOMEOWNER: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: true
        }
        
        case FAILED_SUBMIT_LISTING_HOMEOWNER: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: true,
            completesubmit: true
        }
    
        default: return state
    }
}

export default mlListingHomeowner